/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    this.form = this.container.querySelector('form.searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');

    this.setupEventListeners();
    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        if (this.container.classList.contains('active')) {
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      return;
    }
    this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');    
    var _this = this;
    var ajaxCall1 = fetch(`${theme.routes.search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[limit]')}=50&section_id=predictive-search-custom`)
    .then((response) => {
      this.predictiveSearchResults.classList.remove('loading');
      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      return response.text();
    });

    // Second AJAX call
    var ajaxCall2 = fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=query&${encodeURIComponent('resources[limit]')}=10&resources[limit_scope]=each&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      });

    // Using $.when to handle both AJAX calls
    $.when(ajaxCall1, ajaxCall2).done(function(response1, response2) {
        // Both AJAX calls are complete
        const firstresponse = new DOMParser().parseFromString(response1, 'text/html').querySelector('#shopify-section-predictive-search-custom').innerHTML;
        const secresponse = new DOMParser().parseFromString(response2, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;  
                              
        _this.renderSearchResults(firstresponse,secresponse);
        
    }).fail(function(jqXHR, textStatus, errorThrown) {
        // Handle any errors that occurred during the AJAX calls
        console.error('Error:', textStatus, errorThrown);
    });

    // fetch(`${theme.routes.search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[limit]')}=50&section_id=predictive-search-custom`)
    // .then((response) => {
    //   this.predictiveSearchResults.classList.remove('loading');
    //   if (!response.ok) {
    //     var error = new Error(response.status);
    //     throw error;
    //   }

    //   return response.text();
    // })
    // .then((text) => {
    //   const srresultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search-custom').innerHTML;

    //   fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[limit]')}=10&resources[limit_scope]=each&section_id=predictive-search`)
    //   .then((response) => {
    //     this.predictiveSearchResults.classList.remove('loading');
    //     if (!response.ok) {
    //       var error = new Error(response.status);
    //       throw error;
    //     }

    //     return response.text();
    //   })
    //   .then((text) => {
    //     const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
       
    //     // $(resultsMarkup).find('.side-panel-content--tab-panel.product-panel').append($(srresultsMarkup).find('.side-panel-content--tab-panel.product-panel').html());
    //     // $(resultsMarkup).find('.side-panel-content--tab-panel.article-panel').append($(srresultsMarkup).find('.side-panel-content--tab-panel.article-panel').html());
       
    //     this.renderSearchResults(resultsMarkup);
    //   })
    //   .catch((error) => {
    //     throw error;
    //   });
      
      
    // })
    // .catch((error) => {
    //   throw error;
    // });
    
    
  }

  renderSearchResults(resultsMarkup, secresponse) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.predictiveSearchResults.insertAdjacentHTML('afterbegin', secresponse);

    
    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');

    submitButton.addEventListener('click', () => {
      $(_this.form).append('<input type="hidden" name="type" value="product">');
      _this.form.submit();
    });
  }

  close() {
    this.container.classList.remove('active');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});